import type {ISolicitacaoTipo} from "@models/solicitacoes/solicitacoes.js";
import React from "react";
import {DefaultConsumerPesquisaAutoProps, DefaultPesquisaAuto} from "@shared/specialComponents/DefaultPesquisaAuto.tsx";
import {IGetSolicitacaoTipoFilter} from "@components/solicitacoes/dto/request/IGetSolicitacaoTipoFilter.ts";
import {__solicitacoes_endpoints} from "@components/solicitacoes/endpoints/__solicitacoes_endpoints.ts";

interface TipoSolicitacaoPesquisaProps extends DefaultConsumerPesquisaAutoProps<ISolicitacaoTipo, IGetSolicitacaoTipoFilter> {

}

export function SolicitacaoTipoPesquisa(props: TipoSolicitacaoPesquisaProps) {
    const handleItemSelected = (item: ISolicitacaoTipo | undefined) => {
        if (props.onItemSelected != null) {
            props.onItemSelected(item);
        }
    }

    const formatar = (tipo: ISolicitacaoTipo) => `${tipo.nome} - ${tipo.id}`;

    return (
        <DefaultPesquisaAuto<ISolicitacaoTipo, IGetSolicitacaoTipoFilter>
            endpoint={(x) => __solicitacoes_endpoints.v2.tipo['get-tipos']({...x, include: ['Parametros']})}
            searchField={'nome'}
            itemToString={formatar}
            onItemSelected={handleItemSelected}
            display={{
                name: 'Tipo de solicitação'
            }}
            {...props}
        />
    );
}
